import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { IconButton, Tooltip, Typography, Button, withStyles } from '@material-ui/core';
import { createHistory, hasPermission } from '../../sc-utilities';
import { FindInPage, SettingsRemote } from '@material-ui/icons';
import { copyToClipBoard } from '../../sc-utilities';
import { formatDate } from '../../sc-utilities';
import StatisticList from './StatisticList';
import { isSuperUser } from '../../sc-utilities';
import { snackActions } from '../../sc-utilities/SnackBar';
import { Redirect } from 'react-router-dom';
import StatisticModal from './StatisticModal'
import * as action from '../../np-dashboard/CustomerBar/store/actions';
import * as actions from './store/statisticActions';
import { getSecurazeSolution, getSecurazeStandard } from '../ProductOverview/ProductsAll';
import { fetchSecurazeSolutions } from '../../sc-admin/SecurazeSolution/store/securazeSolutionActions';
import { CustomChip, getEraseStatus, getVerificationStatus } from '../ProductOverview/utils';

const styles = theme => ({
    "@global": {
        "[class*='buttonsCustomer']": {
            margin: theme.spacing(),
            fontSize: '13px',
            width: '100%',
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.buttonText.default
            },
        },
        "[class*='.MuiButton-root']": {
            minWidth: '24px',
            borderRadius: '1px'
        },
        "[class*='paletteButtons']": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.buttonText.default,
            margin: theme.spacing(),
            minWidth: '24px',
            borderRadius: '1px',
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
            },
        },
    },
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingTop: theme.spacing(),
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    remote: {
        textDecoration: 'none',
        color: 'white'
    },
    chip_NotErased: {
        color: theme.palette.warning.dark,
        padding: 1,
        fontSize: 12
    },
    chip_InProgress: {
        color: theme.palette.customInProgress.dark,
        padding: 1,
        fontSize: 12
    },
    chip_Error: {
        color: theme.palette.error.dark,
        padding: 1,
        margin: 1,
        fontSize: 12
    },
    chip_Warning: {
        color: theme.palette.error.light,
        padding: 1,
        fontSize: 12
    },
    chip_Aborted: {
        color: theme.palette.aborted.main,
        padding: 1,
        fontSize: 12
    },
    chip_Erased: {
        color: theme.palette.success.dark,
        padding: 1,
        fontSize: 12
    },
    chip_Started: {
        color: theme.palette.primary.main,
        padding: 1,
        fontSize: 12
    },
    wipeProgress: {
        padding: '10px'
    },
    paletteButtons: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.buttonText.default,
        margin: theme.spacing(),
        minWidth: '24px',
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    linearColorPrimary: {
        backgroundColor: theme.palette.info.light,
    },
    linearBarColorPrimary: {
        backgroundColor: theme.palette.info.dark,
    },
    textField: {
        marginLeft: 10
    },

    storage_WipeMethod: {
        fontSize: 12
    },
    buttonsCustomer: {
        color: theme.palette.primary.main,
        margin: theme.spacing(1),
        fontSize: '13px',
        width: '100%',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
    },
});

export const handleChangeCustomer = async (onChangeActiveCustomer, redirectOptions) => {
    await onChangeActiveCustomer(redirectOptions.customerID, redirectOptions.redirectPath)
};

const Statistic = props => {
    const tableRef = useRef();
    const { classes, translations, permissions, onFetchErasureMethods, columns, activeCustomer, activeCustomerName, onChangeActiveCustomer, onFetchSecurazeSolutions } = props;
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, productID: null, redirectPath: '', open: false, product: '', customerID: null });
    let visible = columns && columns['Statistic'];
    const [erasureMethods, setErasureMethod] = useState({ data: null, loading: false });
    const [securazeSolutionsLookup, setSecurazeSolutionsLookup] = useState({ data: null, loading: false });

    useEffect(() => {

        const fetchErasureMethods = async () => {
            let erasureMethodData = await onFetchErasureMethods({ ActiveCustomerID: activeCustomer });
            let formattedErasureMethods = erasureMethodData.reduce(
                (obj, item) => Object.assign(obj, { [item.value]: item.displayValue }), {});
            setErasureMethod({ data: formattedErasureMethods, loading: true });
        };
        fetchErasureMethods()
        return () => { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {

        const fetchSecurazeSolutions = async () => {
            setSecurazeSolutionsLookup({ data: null, loading: true });
            let data = await onFetchSecurazeSolutions({ ActiveCustomerID: activeCustomer });
            let securazeSolutionsLookup = data?.reduce((acc, item) => {
                acc[item.Key] = item.LongName;
                return acc;
            }, {});
            setSecurazeSolutionsLookup({ data: securazeSolutionsLookup, loading: false });
        };
        hasPermission(permissions, "securaze_solution_list") && fetchSecurazeSolutions();
        return () => { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getModel = product => {
        switch (product.Type) {
            case 'MobileProduct':
                return product && product.MobileProduct ? product.MobileProduct.MobileProductModel : '-';
            case 'PCProduct':
                return product && product.PCProduct ? product.PCProduct.Name : '-';
            case 'StorageProduct':
                return product && product.Components && product.Components[0] && product.Components[0].ComponentModel ? product.Components[0].ComponentModel : '-';
            case 'WatchProduct':
                return product && product.WatchProduct ? product.WatchProduct.ProductModel : '-';
            case 'HeadphoneProduct':
                return product && product.HeadphoneProduct ? product.HeadphoneProduct.ProductModel : '-';
            default:
                return 'Unknown';
        }
    }

    const goToColli = (event, customerID, name) => {
        let colliInventoryID = event.currentTarget.value;
        if (customerID !== activeCustomer) {
            setRedirectOptions({ ...redirectOptions, open: true, product: name, customerID: customerID });
            return;
        }
        createHistory();
        setRedirectOptions({
            ...redirectOptions,
            redirect: true,
            redirectPath: `/logistic/container?ColliInventoryID=${colliInventoryID}`
        });
    }

    const getDiagnoseStatus = (data) => {

        let inProgress = 0;
        let passed = 0;
        let failed = 0;
        let aborted = 0;
        let skipped = 0;
        let notStarted = 0;
        let started = 0;

        for (var diagnoseData of data) {
            switch (diagnoseData.Status) {
                case 'passed':
                    passed++;
                    break;
                case 'inprogress':
                    inProgress++;
                    break;
                case 'failed':
                    failed++;
                    break;
                case 'skipped':
                    skipped++;
                    break;
                case 'notstarted':
                    notStarted++;
                    break;
                case 'aborted':
                    aborted++;
                    break;
                case 'started':
                    started++;
                    break;
                default:
                    notStarted++;
                    break;
            }
        }
        return <>
            {passed > 0 ? <CustomChip key='erasedChipStatus' className={'chip_Erased'} value={`${translations["passed"] || "Passed"}: ${passed}`} /> : null}
            {inProgress > 0 ? <CustomChip key='notErasedChipStatus' className={'chip_InProgress'} value={`${translations["in_progress"] || 'In progress'}: ${inProgress}`} /> : null}
            {failed > 0 ? <CustomChip key='inProgressChipStatus' className={'chip_NotErased'} value={`${translations["failed"] || 'Failed'}: ${failed}`} /> : null}
            {skipped > 0 ? <CustomChip key='warningChipStatus' className={'chip_Warning'} value={`${translations["skipped"] || "Skipped"}: ${skipped}`} /> : null}
            {notStarted > 0 ? <CustomChip key='notErasedChipStatus' className={'chip_NotStarted'} value={`${translations["not_started"] || "Not started"} : ${notStarted}`} /> : null}
            {aborted > 0 ? <CustomChip key='abortedChipStatus' className={'chip_Aborted'} value={`${translations["aborted_by_user"] || "Aborted by user"} : ${aborted}`} /> : null}
            {started > 0 ? <CustomChip key='startedChipStatus' className={'chip_Started'} value={`${translations["started"] || "Started"} : ${started}`} /> : null}
            {!passed && !inProgress && !failed && !skipped && !notStarted && !aborted && !started ? <CustomChip key='noStoragesChipStatus' className={'chip_InProgress'} value={translations['short_not_assigned'] || 'n/a'} /> : null}

        </>
    }

    const createPaletteActionForProduct = (statistic, paletteType, classes, customerID, name) => {
        return statistic ?
            <Button color='primary'
                key={statistic} variant="contained" className={classes.paletteButtons} value={statistic}
                size='small' onClick={event => {
                    switch (paletteType) {
                        case 'MobileProduct':
                            return hasPermission(permissions, 'product_list') ? goToMobileProduct(event, customerID, name) : null
                        case 'PCProduct':
                            return hasPermission(permissions, 'product_list') ? goToPcProduct(event, customerID, name) : null
                        case 'DisplayProduct':
                            return hasPermission(permissions, 'product_list') ? goToDisplayProduct(event, customerID, name) : null
                        case 'StorageProduct':
                            return hasPermission(permissions, 'product_list') ? goToStorageProduct(event, customerID, name) : null;
                        case 'WatchProduct':
                            return hasPermission(permissions, 'product_list') ? goToWatchProduct(event, customerID, name) : null;
                        case 'HeadphoneProduct':
                            return hasPermission(permissions, 'product_list') ? goToHeadphoneProduct(event, customerID, name) : null;
                        default:
                            return null;
                    }
                }}>
                {statistic}
            </Button> : '[empty]';
    }

    const goToOrder = (event, customerID, name) => {
        let orderInventoryID = event.currentTarget.value;
        if (customerID !== activeCustomer) {
            setRedirectOptions({
                ...redirectOptions,
                open: true,
                product: name,
                customerID: customerID,
                redirectPath: `/logistic/orders?OrderInventoryID=${orderInventoryID}`
            });
            return;
        }
        createHistory();
        setRedirectOptions({
            ...redirectOptions,
            redirect: true,
            redirectPath: `/logistic/orders?OrderInventoryID=${orderInventoryID}`
        });
    }

    const goToTransportColli = (event, customerID, name) => {
        let transportColliInventoryID = event.currentTarget.value;
        if (customerID !== activeCustomer) {
            setRedirectOptions({
                ...redirectOptions,
                open: true,
                product: name,
                customerID: customerID,
                redirectPath: `/logistic/transport-container?TransportColliInventoryID=${transportColliInventoryID}`
            });
            return;
        }
        createHistory();
        setRedirectOptions({
            ...redirectOptions,
            redirect: true,
            redirectPath: `/logistic/transport-container?TransportColliInventoryID=${transportColliInventoryID}`
        });
    }

    const handleOpenAnydesk = async (event, rowData) => {
        copyToClipBoard(rowData.RemotePassword);
        snackActions.snackBarComponent((<Typography variant={'caption'} ><a className={classes.remote} rel="noopener noreferrer" href="https://anydesk.com/" target="_blank">
            {translations['securaze_remote_anydesk_snackbar_message'] || "Password is copied to clipboard. NOTE: Make sure you have installed AnyDesk"}
        </a></Typography>), 'info');
        const element = document.createElement('a');
        element.href = `anydesk:${rowData.RemoteID}`;
        element['data-href-alt'] = "https://anydesk.com/"
        return element.click();
    };

    const handleOpenRustdesk = async (event, rowData) => {
        copyToClipBoard(rowData.RemotePassword);
        snackActions.snackBarComponent((
            <Typography variant={'caption'}>
                <a
                    className={classes.remote}
                    rel="noopener noreferrer"
                    href="https://rustdesk.com/"
                    target="_blank"
                >
                    {translations['securaze_remote_rustdesk_snackbar_message'] || "Password is copied to clipboard. NOTE: Make sure you have installed RustDesk"}
                </a>
            </Typography>
        ), 'info');
        const element = document.createElement('a');
        element.href = `rustdesk://${rowData.RemoteID}`;
        element['data-href-alt'] = "https://rustdesk.com/";
        return element.click();
    };

    const goToMobileProductPage = (event, customerID, name) => {
        const activeCustomerParams = `&ActiveCustomerID=${customerID}&ActiveCustomerName=${name}`;

        let mobileProductInventoryID = event.currentTarget.value;
        if (customerID !== activeCustomer) {
            setRedirectOptions({
                ...redirectOptions,
                open: true,
                product: name,
                customerID: customerID,
                redirectPath: `/mobile-product/details?productID=${mobileProductInventoryID}&type=MobileProduct${activeCustomerParams}`
            });
            return;
        }
        createHistory();
        setRedirectOptions({
            ...redirectOptions,
            redirect: true,
            mobileProductInventoryID: event.currentTarget.value,
            redirectPath: `/mobile-product/details?productID=${mobileProductInventoryID}&type=MobileProduct${activeCustomerParams}`
        });
    };

    const goToStorageProductPage = (event, customerID, name) => {
        const activeCustomerParams = `&ActiveCustomerID=${customerID}&ActiveCustomerName=${name}`;

        let storageProductInventoryID = event.currentTarget.value;
        if (customerID !== activeCustomer) {
            setRedirectOptions({
                ...redirectOptions,
                open: true,
                product: name,
                customerID: customerID,
                redirectPath: `/storage-product/details?productID=${storageProductInventoryID}&type=StorageProduct${activeCustomerParams}`
            });
            return;
        }
        createHistory();
        setRedirectOptions({
            ...redirectOptions,
            redirect: true,
            redirectPath: `/storage-product/details?productID=${storageProductInventoryID}&type=StorageProduct${activeCustomerParams}`
        });
    };

    const goToPcProductPage = (event, customerID, name) => {
        const activeCustomerParams = `&ActiveCustomerID=${customerID}&ActiveCustomerName=${name}`;

        let pcProductInventoryID = event.currentTarget.value;
        if (customerID !== activeCustomer) {
            setRedirectOptions({
                ...redirectOptions,
                open: true,
                product: name,
                customerID: customerID,
                redirectPath: `/pc-product/details?productID=${pcProductInventoryID}&type=PCProduct${activeCustomerParams}`
            });
            return;
        }
        createHistory();
        setRedirectOptions({
            ...redirectOptions,
            redirect: true,
            redirectPath: `/pc-product/details?productID=${pcProductInventoryID}&type=PCProduct${activeCustomerParams}`
        });
    };

    const goToWatchProductPage = (event, customerID, name) => {
        let watchProductInventoryID = event.currentTarget.value;
        if (customerID !== activeCustomer) {
            setRedirectOptions({
                ...redirectOptions,
                open: true,
                product: name,
                customerID: customerID,
                redirectPath: `/watch-product/details?productID=${watchProductInventoryID}&type=WatchProduct`
            });
            return;
        }
        createHistory();
        setRedirectOptions({
            ...redirectOptions,
            redirect: true,
            redirectPath: `/watch-product/details?productID=${watchProductInventoryID}&type=WatchProduct`
        });
    };

    const goToHeadphoneProductPage = (event, customerID, name) => {
        let headphoneProductInventoryID = event.currentTarget.value;
        if (customerID !== activeCustomer) {
            setRedirectOptions({
                ...redirectOptions,
                open: true,
                product: name,
                customerID: customerID,
                redirectPath: `/headphone-product/details?productID=${headphoneProductInventoryID}&type=HeadphoneProduct`
            });
            return;
        }
        createHistory();
        setRedirectOptions({
            ...redirectOptions,
            redirect: true,
            redirectPath: `/headphone-product/details?productID=${headphoneProductInventoryID}&type=HeadphoneProduct`
        });
    };

    const redirectToCustomer = id => {
        createHistory();
        setRedirectOptions({
            ...redirectOptions,
            redirect: true,
            redirectPath: `/admin/customers/details?customerID=${id}`
        });
    };

    const createPaletteAction = (statistic, paletteType, customerID, name) => {
        return statistic[`${paletteType}ID`] ?
            <Button className={classes['paletteButtons']} color='primary'
                key={statistic[`${paletteType}ID`]} variant="contained"
                value={statistic[paletteType][`${paletteType}InventoryID`]} size='small'
                onClick={event => {
                    switch (paletteType) {
                        case 'Colli':
                            return hasPermission(permissions, 'colli_list') ? goToColli(event, customerID, name) : null
                        case 'Order':
                            return hasPermission(permissions, 'order_list') ? goToOrder(event, customerID, name) : null
                        case 'TransportColli':
                            return hasPermission(permissions, 'transport_colli_list') ? goToTransportColli(event, customerID, name) : null
                        default:
                            return null;
                    }
                }}
            >
                {statistic[paletteType][`${paletteType}InventoryID`]}
            </Button> : '[empty]';
    };

    const getStorageComponentData = (components, field) => {
        if (components) {
            let prettyPrint = components.slice(0, 3).map((component, index) => {
                let storageComponent = component.StorageComponents;
                if (!storageComponent) {
                    return 'n/a';
                }
                switch (field) {
                    case 'WipeStatus':
                        if (storageComponent[field] === 'inprogress') {
                            return <CustomChip key={`${component.ComponentID}_wipeStatus`} value={`${storageComponent.WipeProgress ? storageComponent.WipeProgress : 0}% ${translations && translations['in_progress'] ? translations['in_progress'] : 'In progress'}`}
                                className={`chip_${getEraseStatus(storageComponent[field], translations, true)}`} />;
                        }
                        let labelText1 = getEraseStatus(storageComponent[field], translations);
                        return <CustomChip key={`${component.ComponentID}_wipeStatus`} value={labelText1}
                            className={`chip_${getEraseStatus(storageComponent[field], translations, true)}`} />;
                    case 'VerificationStatus':
                        if (storageComponent[field] === 'inprogress') {
                            return <CustomChip key={`${component.ComponentID}_verificationStatus`} value={`${storageComponent.VerificationProgress ? storageComponent.VerificationProgress : 0}% ${translations && translations['in_progress'] ? translations['in_progress'] : 'In progress'}`}
                                className={`chip_${getVerificationStatus(storageComponent[field], translations, true)}`} />;
                        }
                        let labelText2 = getVerificationStatus(storageComponent[field], translations);
                        return <CustomChip key={`${component.ComponentID}_verificationStatus`} value={labelText2}
                            className={`chip_${getVerificationStatus(storageComponent[field], translations, true)}`} />;
                    case 'WipeMethod':
                        return <Typography key={`${component.ComponentID}_${index}_wipeMethod`}
                            style={{ fontSize: 12 }}
                            gutterBottom>{erasureMethods.data[storageComponent[field]]}</Typography>;
                    default:
                        return 'n/a';
                }
            });
            return (prettyPrint);
        }
    };

    const goToMobileProduct = (event, customerID, name) => {
        let mobileProductInventoryID = event.currentTarget.value;
        if (customerID !== activeCustomer) {
            setRedirectOptions({
                ...redirectOptions,
                open: true,
                product: name,
                customerID: customerID,
                redirectPath: `/products/mobile-products?InventoryID=${mobileProductInventoryID}`
            });
            return;
        }
        createHistory();
        setRedirectOptions({
            ...redirectOptions,
            redirect: true,
            mobileProductInventoryID: event.currentTarget.value,
            redirectPath: `/products/mobile-products?InventoryID=${mobileProductInventoryID}`
        });
    };

    const goToDisplayProduct = (event, customerID, name) => {
        let displayProductInventoryID = event.currentTarget.value;
        if (customerID !== activeCustomer) {
            setRedirectOptions({
                ...redirectOptions,
                open: true,
                product: name,
                customerID: customerID,
                redirectPath: `/products/displayProducts?InventoryID=${displayProductInventoryID}`
            });
            return;
        }
        createHistory();
        setRedirectOptions({
            ...redirectOptions,
            redirect: true,
            displayProductInventoryID: event.currentTarget.value,
            redirectPath: `/products/displayProducts?InventoryID=${displayProductInventoryID}`
        });
    };

    const goToStorageProduct = (event, customerID, name) => {
        let storageProductInventoryID = event.currentTarget.value;
        if (customerID !== activeCustomer) {
            setRedirectOptions({
                ...redirectOptions,
                open: true,
                product: name,
                customerID: customerID,
                redirectPath: `/products/storage-products?InventoryID=${storageProductInventoryID}`
            });
            return;
        }
        createHistory();
        setRedirectOptions({
            ...redirectOptions,
            redirect: true,
            storageProductInventoryID: event.currentTarget.value,
            redirectPath: `/products/storage-products?InventoryID=${storageProductInventoryID}`
        });
    };

    const goToPcProduct = (event, customerID, name) => {
        let pcProductInventoryID = event.currentTarget.value;
        if (customerID !== activeCustomer) {
            setRedirectOptions({
                ...redirectOptions,
                open: true,
                product: name,
                customerID: customerID,
                redirectPath: `/products/pc-products?InventoryID=${pcProductInventoryID}`
            });
            return;
        }
        createHistory();
        setRedirectOptions({
            ...redirectOptions,
            redirect: true,
            pcProductInventoryID: event.currentTarget.value,
            redirectPath: `/products/pc-products?InventoryID=${pcProductInventoryID}`
        });
    }

    const goToWatchProduct = (event, customerID, name) => {
        let watchProductInventoryID = event.currentTarget.value;
        if (customerID !== activeCustomer) {
            setRedirectOptions({
                ...redirectOptions,
                open: true,
                product: name,
                customerID: customerID,
                redirectPath: `/products/watch-products?InventoryID=${watchProductInventoryID}`
            });
            return;
        }
        createHistory();
        setRedirectOptions({
            ...redirectOptions,
            redirect: true,
            watchProductInventoryID: event.currentTarget.value,
            redirectPath: `/products/watch-products?InventoryID=${watchProductInventoryID}`
        });
    }

    const goToHeadphoneProduct = (event, customerID, name) => {
        let headphoneProductInventoryID = event.currentTarget.value;
        if (customerID !== activeCustomer) {
            setRedirectOptions({
                ...redirectOptions,
                open: true,
                product: name,
                customerID: customerID,
                redirectPath: `/products/headphone-products?InventoryID=${headphoneProductInventoryID}`
            });
            return;
        }
        createHistory();
        setRedirectOptions({
            ...redirectOptions,
            redirect: true,
            headphoneProductInventoryID: event.currentTarget.value,
            redirectPath: `/products/headphone-products?InventoryID=${headphoneProductInventoryID}`
        });
    }

    const getFormatWipeStarted = (components, field = 'WipeStarted') => {
        let prettyPrint = components.length < 4 ? components.map(component => {
            return <Typography key={`${component.ComponentID}_${parseInt(Math.random() * 99999)}`}
                style={{ fontSize: 12 }}
                gutterBottom>{formatDate(component.StorageComponents[field])}</Typography>
        }) : <>
            <Typography key={`${components[0].ComponentID}_${parseInt(Math.random() * 99999)}`}
                style={{ fontSize: 12 }}
                gutterBottom>{formatDate(components[0].StorageComponents[field])}</Typography>
            <Typography key={`${components[1].ComponentID}_${parseInt(Math.random() * 99999)}`}
                style={{ fontSize: 12 }}
                gutterBottom>{formatDate(components[1].StorageComponents[field])}</Typography>
            <Typography key={`${components[2].ComponentID}_${parseInt(Math.random() * 99999)}`}
                style={{ fontSize: 12 }}
                gutterBottom>{formatDate(components[2].StorageComponents[field])}</Typography>
        </>
        return (prettyPrint);
    }

    const createAction = (productType, productID, customerID, name, deviceOnlineStatus) => {
        return <>
            {productID ?
                <Tooltip title={translations["product_details"] || "Product details"}>
                    <IconButton aria-label={translations["product_details"] || "Product details"} value={productID}
                        onClick={event => {
                            switch (productType) {
                                case 'MobileProduct':
                                    return hasPermission(permissions, 'product_list') ? goToMobileProductPage(event, customerID, name) : null;
                                case 'PCProduct':
                                    return hasPermission(permissions, 'product_list') ? goToPcProductPage(event, customerID, name) : null;
                                case 'StorageProduct':
                                    return hasPermission(permissions, 'product_list') ? goToStorageProductPage(event, customerID, name) : null;
                                case 'WatchProduct':
                                    return hasPermission(permissions, 'product_list') ? goToWatchProductPage(event, customerID, name) : null;
                                case 'HeadphoneProduct':
                                    return hasPermission(permissions, 'product_list') ? goToHeadphoneProductPage(event, customerID, name) : null;
                                default:
                                    return null;
                            }
                        }}>
                        <FindInPage />
                    </IconButton>
                </Tooltip> : '[empty]'}
                <Tooltip component={'span'} title={translations['open_remote_erasure_anydesk'] || 'Open Securaze Remote AnyDesk session'} disabled={!deviceOnlineStatus || !deviceOnlineStatus.RemoteID || !deviceOnlineStatus.RemotePassword}>
                    <IconButton aria-label={translations['open_remote_erasure_anydesk'] || 'Open Securaze Remote AnyDesk session'}
                        onClick={(event) => handleOpenAnydesk(event, deviceOnlineStatus || {})}>
                        <SettingsRemote />
                    </IconButton>
                </Tooltip>
                <Tooltip component={'span'} title={translations['open_remote_erasure_rustdesk'] || 'Open Securaze Remote RustDesk session'} disabled={!deviceOnlineStatus || !deviceOnlineStatus.RemoteID || !deviceOnlineStatus.RemotePassword}>
                    <IconButton aria-label={translations['open_remote_erasure_rustdesk'] || 'Open Securaze Remote RustDesk session'}
                        onClick={(event) => handleOpenRustdesk(event, deviceOnlineStatus || {})}>
                        <SettingsRemote />
                    </IconButton>
                </Tooltip>
        </>
    };


    let tableColumns = [
        {
            title: translations["action"] || 'Action', field: 'Action', filtering: false, cellStyle: { minWidth: 150, maxWidth: 150 },
            hidden: visible ? visible['Action'] : false,
            export: false,
            render: rowData => {
                return createAction(rowData.Type, rowData.ProductID, rowData?.CustomerID || null, rowData?.Customer?.Name || translations['short_not_assigned'] || 'n/a', rowData.DeviceOnlineStatus ?? {})
            }
        },
        {
            title: translations["customer_name"] || 'Customer name', field: 'CustomerName',
            hidden: visible ? visible['CustomerName'] : false,
            render: rowData => {
                return <Button key={rowData?.Customer?.CustomerID || ''}
                    color='primary'
                    style={{ margin: '2%' }}
                    className={classes.buttonsCustomer}
                    onClick={() => redirectToCustomer(rowData?.Customer?.CustomerID || translations['short_not_assigned'] || 'n/a')}>{rowData?.Customer?.Name || translations['short_not_assigned'] || 'n/a'}</Button>
            }
        },
        {
            title: translations["wipe_started"] || 'Wipe started', field: 'WipeStarted', filtering: false,
            hidden: visible ? visible['WipeStarted'] : false,
            render: rowData => {
                return getFormatWipeStarted(rowData.Components)
            }
        },
        {
            title: translations["verification_started"] || 'Verification started', field: 'VerificationStarted', filtering: false,
            hidden: visible ? visible['VerificationStarted'] : false,
            render: rowData => {
                return getFormatWipeStarted(rowData.Components, 'VerificationStarted')
            }
        },
        {
            title: translations["order"] || 'Order', field: 'OrderInventoryID',
            hidden: visible ? visible['OrderInventoryID'] : false,
            render: rowData => {
                return rowData.Order ? createPaletteAction(rowData, 'Order', rowData?.CustomerID || null, rowData?.Customer?.Name || translations['short_not_assigned'] || 'n/a') : translations['short_not_assigned'] || 'n/a'
            }
        },
        {
            title: translations["transport_colli"] || 'Transport colli', field: 'TransportColliInventoryID',
            hidden: visible ? visible['TransportColliInventoryID'] : false,
            render: rowData => {
                return rowData.TransportColli ? createPaletteAction(rowData, 'TransportColli', rowData?.CustomerID || null, rowData?.Customer?.Name || translations['short_not_assigned'] || 'n/a') : translations['short_not_assigned'] || 'n/a'
            }
        },
        {
            title: translations["colli"] || 'Colli', field: 'ColliInventoryID',
            hidden: visible ? visible['ColliInventoryID'] : false,
            render: rowData => {
                return rowData ? createPaletteAction(rowData, 'Colli', rowData?.CustomerID || null, rowData?.Customer?.Name || translations['short_not_assigned'] || 'n/a') : translations['short_not_assigned'] || 'n/a'
            }
        },
        {
            title: translations["inventory_id"] || 'Securaze ID', field: 'InventoryID',
            hidden: visible ? visible['InventoryID'] : false,
            render: rowData => {
                return rowData.InventoryID ? createPaletteActionForProduct(rowData.InventoryID, rowData.Type, classes, rowData?.CustomerID || null, rowData?.Customer?.Name || translations['short_not_assigned'] || 'n/a') : translations['short_not_assigned'] || 'n/a'
            }
        },
        {
            title: translations["vendor"] || 'Vendor', field: 'Vendor',
            hidden: visible ? visible['Vendor'] : false,
            render: rowData => {
                return <Typography key={rowData.ProductID} style={{ fontSize: 12 }}
                    gutterBottom>{rowData.Vendor}</Typography>
            }
        },
        {
            title: translations["model"] || 'Model', field: 'Model', cellStyle: { minWidth: 250, maxWidth: 250 },
            hidden: visible ? visible['Model'] : false,
            render: rowData => {
                return <Typography key={`${rowData.ProductID}_model`} style={{ fontSize: 12 }}
                    gutterBottom>{getModel(rowData)}</Typography>
            }
        },
        {
            title: translations["wipe_status"] || 'Wipe status', field: 'WipeStatus',
            cellStyle: { minWidth: 100, maxWidth: 100 },
            hidden: visible ? visible['WipeStatus'] : false,
            lookup: { 'erased': translations['erased'] || 'Erased', 'noterased': translations['not_erased'] || 'Not Erased', 'inprogress': translations['in_progress'] || 'In progress', 'error': translations['error'] || 'Error', 'warning': translations['warning'] || 'Warning', 'aborted': translations['report_aborted'] || 'Aborted by user', 'started': translations['started'] || 'Started' },
            defaultFilter: ['erased', 'noterased', 'inprogress', 'error', 'warning', 'aborted', 'started'], render: rowData => {
                return getStorageComponentData(rowData.Components, 'WipeStatus');
            }
        },
        {
            title: translations["verification_status"] || 'Verification status', field: 'VerificationStatus',
            cellStyle: { minWidth: 100, maxWidth: 100 },
            hidden: visible ? visible['VerificationStatus'] : false,
            lookup: { 'verified': translations['verified'] || 'Verified', 'notverified': translations['not_verified'] || 'Not Verified', 'inprogress': translations['in_progress'] || 'In progress', 'error': translations['error'] || 'Error', 'warning': translations['warning'] || 'Warning', 'aborted': translations['report_aborted'] || 'Aborted by user', 'started': translations['started'] || 'Started' },
            defaultFilter: ['verified', 'notverified', 'inprogress', 'error', 'warning', 'aborted', 'started'], render: rowData => {
                return getStorageComponentData(rowData.Components, 'VerificationStatus');
            }
        },
        {
            title: translations["securaze_standard"] || 'Securaze Standard', field: 'WipeMethod',
            hidden: visible ? visible['WipeMethod'] : false,
            cellStyle: { minWidth: 100, maxWidth: 100 },
            lookup: erasureMethods.data || {},
            render: rowData => {
                return getSecurazeStandard(rowData);
            }
        },
        {
            title: translations["securaze_solution"] || 'Securaze Solution', field: 'SecurazeSolution',
            hidden: visible ? visible['SecurazeSolution'] : false,
            cellStyle: { minWidth: 100, maxWidth: 100 },
            lookup: securazeSolutionsLookup.data || {},
            sorting: false,
            render: rowData => {
                return <Typography variant={'caption'}>{getSecurazeSolution(rowData)}</Typography>;
            }
        },
        {
            title: translations["responsible_user"] || 'Responsible User', field: 'ResponsibleUser',
            hidden: visible ? visible['ResponsibleUser'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.ProcessingSession?.ResponsibleUser ?? (translations['short_not_assigned'] || 'n/a')}</Typography>;
            }
        },
    ]

    if (!isSuperUser()) {
        tableColumns.splice(1, 1);
    }

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'statistic_list') && erasureMethods.loading ?
                <StatisticList getDiagnoseStatus={getDiagnoseStatus} method={erasureMethods.data} setRedirectOptions={setRedirectOptions} redirectOptions={redirectOptions} tableColumns={tableColumns} tableRef={tableRef} />
                : null}
            {redirectOptions.open ?
                <StatisticModal open={redirectOptions.open} activeCustomerName={activeCustomerName} product={redirectOptions.product} handleChangeCustomer={() => handleChangeCustomer(onChangeActiveCustomer, redirectOptions)} handleCloseSafe={() => setRedirectOptions({ ...redirectOptions, open: !redirectOptions.open })} translations={translations} activeCustomer={activeCustomer} ></StatisticModal>
                : null}
        </div >
    );
}

const mapDispatchToProps = dispatch => {
    return {
        onFetchErasureMethods: (user) => (dispatch(actions.fetchErasureMethod(user))),
        onChangeActiveCustomer: (customerID, path) => dispatch(action.changeActiveCustomer(customerID, path)),
        onFetchSecurazeSolutions: (data) => dispatch(fetchSecurazeSolutions(data)),
    };
};

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID || null,
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || [],
        activeCustomerName: state.core.login.activeCustomer.Name,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {}
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(Statistic));